/* eslint-disable no-alert */
import { SetStateAction, useCallback, useEffect, useState } from "react";
import { Input, Button, Tooltip, Table, Space, Popconfirm } from "antd";
import {
  Trash,
  Edit2,
  Refresh2,
  Setting2,
  RowVertical,
  Maximize4,
} from "iconsax-react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import PageHeader from "../../../components/PageHeader";

import { useProfiles } from "../../../hooks/profile";
import { useClass, ClassProps } from "../../../hooks/class";
import { useAuth } from "../../../hooks/auth";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../components/Breadcrumb";

import {
  Container,
  Main,
  SearchBar,
  Content,
  HeaderContent,
  Itens,
  TableContainer,
} from "./styles";

interface DataType {
  key: "uid";
  uid: string;
  name: string;
  status: string;
  dataDeAdicao: string;
  tumblr: string;
  description: string;
}

function ClassList() {
  const navigate = useNavigate();
  const { getAll } = useProfiles();
  const { getClasses, deleteClass } = useClass();
  const [busca, setBusca] = useState("");
  const [data, setData] = useState<ClassProps[]>([]);
  const classesWithSearch = data.filter((current: ClassProps): boolean => {
    return current.name.toUpperCase().includes(busca.toLocaleUpperCase());
  });

  const ListagemDeClasses = useCallback(async () => {
    try {
      const getListaDeClasses = await getClasses();
      setData(getListaDeClasses);
    } catch (e) {
      console.log(e);
    }
  }, [getClasses]);

  useEffect(() => {
    ListagemDeClasses();
  }, [ListagemDeClasses]);

  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  async function handleDeleteClass(uid: string) {
    try {
      Swal.fire({
        title: "Deletando...",
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: async () => {
          Swal.showLoading();
          await deleteClass(uid);
          await ListagemDeClasses();
          Swal.close();
        },
      });
    } catch (e: any) {
      console.log(e.message);
    }
  }

  function redirect(record: DataType) {
    navigate(`/classDetails/`, {
      state: {
        id: record.uid,
        name: record.name,
        tumblr: record.tumblr,
        description: record.description,
      },
    });
  }

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    { title: "Status", dataIndex: "status", key: "status" },
    { title: "Data de adição", dataIndex: "begin", key: "begin" },
    {
      title: "Ações",
      dataIndex: "",
      key: "x",
      render: (record: DataType) => (
        <Space size="middle">
          <Button
            type="default"
            shape="circle"
            onClick={() => redirect(record)}
          >
            <Edit2 size={16} />
          </Button>

          <Popconfirm
            placement="topRight"
            title="Deseja realmente deletar uma turma?"
            onConfirm={() => handleDeleteClass(record.uid)}
            okText="Sim"
            cancelText="Não"
          >
            <Button type="primary" danger shape="circle">
              <Trash size={16} />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // ======================================================

  return (
    <Container id="page">
      <PageHeader
        title="Gerenciamento de Turmas."
        description="Estas são todas as Turmas cadastrados no Bilíngua"
        type="manager"
      />
      <Main>
        <Breadcrumb
          items={[
            { label: "Gerenciamento", link: "/manager" },
            { label: "Turmas", active: true },
          ]}
        />
        <SearchBar className="search">
          <Input
            size="large"
            placeholder="Digite um termo para buscar"
            value={busca}
            onChange={(e: { target: { value: SetStateAction<string> } }) => {
              setBusca(e.target.value);
            }}
            type="text"
            style={{ height: "4rem", marginRight: "2rem" }}
          />
          <Button
            type="primary"
            htmlType="button"
            size="large"
            style={{
              border: "0",
              backgroundColor: "var(--color-secondary-dark)",
              width: "15rem",
              height: "5rem",
              borderRadius: "0.8rem",
            }}
          >
            Buscar
          </Button>
        </SearchBar>

        <Content className="content">
          <HeaderContent className="headerContent">
            Lista de Turmas cadastradas
            <span />
            <Itens className="itens">
              <span style={{ width: "10%" }} />
              <Tooltip title="Cadastre um Novo Profissional">
                <Button
                  type="primary"
                  htmlType="button"
                  style={{
                    border: "0",
                    backgroundColor: "var(--color-secondary-dark)",
                    borderRadius: "0.8rem",
                  }}
                  onClick={() => navigate("/new-class")}
                >
                  + Criar nova turma
                </Button>
              </Tooltip>
              <Refresh2 size={18} onClick={() => getClasses()} />
              <RowVertical size={18} />
              <Setting2 size={18} />
              <Maximize4 size={18} />
            </Itens>
          </HeaderContent>

          <TableContainer className="table">
            <Table
              rowSelection={{
                type: "checkbox",
                onSelect: (record) => {
                  console.log(record);
                },
              }}
              columns={columns}
              dataSource={classesWithSearch}
              pagination={{ hideOnSinglePage: true }}
              rowKey="uid"
            />
          </TableContainer>
        </Content>
      </Main>
      <Footer />
    </Container>
  );
}

export default ClassList;
